/* TS Knivguide, versjon 2 (11/10 2026). Hører til sections/ts-knivguide.liquid.
   Utvalget er alle kniver på lager i kolleksjonen seksjonen peker på. Motoren velger én kniv og opptil tre alternativer.
   Krav som aldri brytes: knivtypen (fra jobben) og stålets vedlikeholdsbehov (fra stellet).
   Ønsker som kan vike: skaftet (wa/yo) og prisbåndet. Skaftet går foran prisen: finnes riktig skaft i nabobåndet, velges det.
   Motoren ligger mellom MOTOR START og MOTOR SLUTT og er ren JS uten DOM, så den kan kjøres i Node for simulering. */

/* MOTOR START */
var TsKgMotor = (function () {
  /* Tekstene kunden ser kommer fra locales/ via snippets/ts-tekst.liquid. typeof-sjekken er for Node-simuleringen, som ikke har window. */
  var T = ((typeof window !== 'undefined' && window.tsTekst) || {}).knivguide || {};
  function fyll(s, vars) { return String(s).replace(/{{\s*(\w+)\s*}}/g, function (_, k) { return vars[k]; }); }
  /* Jobb → knivtyper i nivåer. Første nivå prøves ferdig før neste. */
  var TYPER = {
    alt: [['gyuto', 'santoku', 'bunka']],
    gronnsaker: [['nakiri'], ['santoku', 'bunka']],
    kjott: [['gyuto', 'sujihiki']],
    presis: [['petty']],
    /* 31/10 2026 (t3): «Vet ikke» på jobben = samme som «Litt av alt» (en kokkekniv er det tryggeste første valget). */
    vetikke: [['gyuto', 'santoku', 'bunka']]
  };
  /* Standardlengde per type i mm. Guiden spør ikke om lengde, men foretrekker kniver nær standarden. */
  var STANDARD = { gyuto: 210, santoku: 170, bunka: 180, nakiri: 165, petty: 135, sujihiki: 240 };
  var BAAND = ['lav', 'mid', 'hoymid', 'hoy'];
  /* Stell → hvilke vedlikeholdsnivåer som er lov. lett = Lettstelt, litt = Trenger litt oppfølging, omsorg = Elsker omsorg. */
  var STELLNIVAA = { hand: ['lett', 'litt', 'omsorg', ''], ofte: ['lett', 'litt'], vask: ['lett'], gave: ['lett'] };
  var STD = {
    grenser: [1400, 3000, 5000],
    staal: {
      rustfritt: T.staal_rustfritt,
      karbon: T.staal_karbon,
      semi: T.staal_semi
    },
    bruk: {
      alt: T.bruk_alt,
      gronnsaker: T.bruk_gronnsaker,
      kjott: T.bruk_kjott,
      presis: T.bruk_presis
    },
    stell: {
      hand: T.stell_hand,
      ofte: T.stell_ofte,
      vask: T.stell_vask,
      gave: T.stell_gave
    },
    kledning: T.kledning
  };
  var GRENSER, STAAL, BRUK, STELL, KLEDNING;
  function flett(std, ny) {
    var ut = {};
    Object.keys(std).forEach(function (k) { ut[k] = (ny && typeof ny[k] === 'string' && ny[k].trim()) ? ny[k] : std[k]; });
    return ut;
  }
  function oppsett(o) {
    o = o || {};
    var g = o.grenser;
    GRENSER = (g && g.length === 3 && g.every(function (x) { return typeof x === 'number' && isFinite(x); }) && g[0] < g[1] && g[1] < g[2]) ? g.slice() : STD.grenser.slice();
    var t = o.tekster || {};
    STAAL = flett(STD.staal, t.staal);
    BRUK = flett(STD.bruk, t.bruk);
    STELL = flett(STD.stell, t.stell);
    KLEDNING = (typeof t.kledning === 'string' && t.kledning.trim()) ? t.kledning : STD.kledning;
  }
  oppsett();

  function baand(pris) {
    if (pris < GRENSER[0]) return 'lav';
    if (pris < GRENSER[1]) return 'mid';
    if (pris < GRENSER[2]) return 'hoymid';
    return 'hoy';
  }
  /* Valgt bånd, ett opp, ett ned, to opp, to ned. Med maks = 1 bare valgt bånd og naboene. */
  function baandRekke(valgt, maks) {
    var i = BAAND.indexOf(valgt);
    return [0, 1, -1, 2, -2].filter(function (o) { return !maks || Math.abs(o) <= maks; })
      .map(function (o) { return i + o; })
      .filter(function (j) { return j >= 0 && j < BAAND.length; })
      .map(function (j) { return BAAND[j]; });
  }
  function steg() { return ['jobb', 'stell', 'skaft', 'pris']; }
  function stellOk(k, stell) { return (STELLNIVAA[stell] || STELLNIVAA.vask).indexOf(k.vedl || '') !== -1; }
  /* Stål etter vaskevaner. Alltid: karbon med rustfri kledning, annen karbon, semi, rustfritt. Som regel: semi og rustfritt likt, så karbon. */
  function staalRang(k, stell) {
    if (stell === 'hand') {
      if (k.staal === 'karbon') return k.kledning === 'rustfri' ? 0 : 1;
      if (k.staal === 'semi') return 2;
      if (k.staal === 'rustfritt') return 3;
      return 4;
    }
    if (stell === 'ofte') return k.staal === 'karbon' ? 1 : 0;
    return 0;
  }
  function skaftOk(k, s) { return s.skaft === 'egal' || !s.skaft || k.skaft === s.skaft; }
  /* Rekkefølgen når flere passer: skaft, stål, lengde nær standarden (15 mm regnes som likt), favoritt, rekkefølgen i kolleksjonen. */
  function passform(s) {
    return function (a, b) {
      var sa = skaftOk(a, s) ? 0 : 1, sb = skaftOk(b, s) ? 0 : 1;
      if (sa !== sb) return sa - sb;
      var ra = staalRang(a, s.stell), rb = staalRang(b, s.stell);
      if (ra !== rb) return ra - rb;
      var la = a.lengde && STANDARD[a.type] ? Math.floor(Math.abs(a.lengde - STANDARD[a.type]) / 16) : 9;
      var lb = b.lengde && STANDARD[b.type] ? Math.floor(Math.abs(b.lengde - STANDARD[b.type]) / 16) : 9;
      if (la !== lb) return la - lb;
      var fa = a.favoritt ? 0 : 1, fb = b.favoritt ? 0 : 1;
      if (fa !== fb) return fa - fb;
      return a.rekke - b.rekke;
    };
  }
  function velg(alle, s) {
    var nivaaer = TYPER[s.bruk] || [];
    var gyldige = alle.filter(function (k) { return k.tilgjengelig !== false && stellOk(k, s.stell); });
    var sorter = passform(s);
    var onsket = (s.skaft && s.skaft !== 'egal') ? s.skaft : null;
    /* 31/10 2026 (t3): «Vet ikke» på prisen = alle bånd er like gode; passformen alene avgjør, og ingen «litt over/under»-merknad. */
    var alleBaand = !s.pris || s.pris === 'vetikke';
    var rekke = alleBaand ? [null] : baandRekke(s.pris);
    var naer = alleBaand ? [null] : baandRekke(s.pris, 1);
    var vinner = null, vinnerBaand = null;
    function finn(typer, baandene, kreverSkaft) {
      for (var r = 0; r < baandene.length; r++) {
        var pool = gyldige.filter(function (k) {
          return typer.indexOf(k.type) !== -1 && (baandene[r] === null || baand(k.pris) === baandene[r]) && (!kreverSkaft || k.skaft === onsket);
        });
        if (pool.length) { pool.sort(sorter); vinner = pool[0]; vinnerBaand = baandene[r]; return true; }
      }
      return false;
    }
    for (var n = 0; n < nivaaer.length && !vinner; n++) {
      /* Skaft først: riktig skaft i valgt bånd, så ett opp og ett ned. Deretter alle skaft, valgt bånd først. */
      if (onsket && finn(nivaaer[n], naer, true)) break;
      finn(nivaaer[n], rekke, false);
    }
    if (!vinner) return { vinner: null, andre: [], toyd: null, skaftMangler: false };

    /* Alternativer: samme jobb og stell, fra valgt prisbånd, nabobåndene og vinnerens bånd. Nærmeste bånd først, så nivå, så passform.
       Maks én kniv per serie. */
    var alleTyper = [].concat.apply([], nivaaer);
    function niva(k) { for (var i = 0; i < nivaaer.length; i++) { if (nivaaer[i].indexOf(k.type) !== -1) return i; } return 99; }
    var lov = naer.indexOf(vinnerBaand) === -1 ? naer.concat([vinnerBaand]) : naer;
    function lovIdx(k) { return alleBaand ? 0 : lov.indexOf(baand(k.pris)); }
    var kandidater = gyldige.filter(function (k) { return k !== vinner && alleTyper.indexOf(k.type) !== -1 && lovIdx(k) !== -1; })
      .sort(function (a, b) {
        var ra = lovIdx(a), rb = lovIdx(b);
        if (ra !== rb) return ra - rb;
        if (niva(a) !== niva(b)) return niva(a) - niva(b);
        return sorter(a, b);
      });
    var brukt = {}; brukt[vinner.serie] = true;
    var andre = [];
    /* 2/11 2026 (eiervalg): maks én kniv per merke blant alternativene, så kunden ser tre ulike merker i stedet for tre fra samme smed. */
    function merke(k) { return (k.merke || '').toLowerCase(); }
    var merker = {};
    kandidater.forEach(function (k) {
      if (andre.length >= 3 || brukt[k.serie] || merker[merke(k)]) return;
      brukt[k.serie] = true; merker[merke(k)] = true; andre.push(k);
    });
    /* Er vinneren karbon, skal minst ett alternativ være rustfritt. */
    if (vinner.staal === 'karbon' && andre.length && !andre.some(function (k) { return k.staal === 'rustfritt'; })) {
      var tatt = {}; tatt[vinner.serie] = true;
      andre.slice(0, andre.length - 1).forEach(function (k) { tatt[k.serie] = true; });
      var resten = andre.slice(0, andre.length - 1).map(merke);
      var rustfri = kandidater.filter(function (k) { return k.staal === 'rustfritt' && !tatt[k.serie] && resten.indexOf(merke(k)) === -1; })[0];
      if (rustfri) andre[andre.length - 1] = rustfri;
    }
    var toyd = null;
    if (!alleBaand && vinnerBaand !== s.pris) toyd = BAAND.indexOf(vinnerBaand) > BAAND.indexOf(s.pris) ? 'over' : 'under';
    return { vinner: vinner, andre: andre, toyd: toyd, skaftMangler: !!onsket && vinner.skaft !== onsket };
  }
  /* Begrunnelsen: svaret, «Passer for» fra knivtypen, stålet, og kledningen når kjernen er karbon med rustfri kledning. */
  function grunn(k, s) {
    var deler = [(BRUK[s.bruk] || T.bruk_fallback) + (STELL[s.stell] || '.')];
    if (k.passer) deler.push(k.passer);
    if (STAAL[k.staal]) deler.push(STAAL[k.staal]);
    if (k.staal === 'karbon' && k.kledning === 'rustfri') deler.push(KLEDNING);
    return deler.join(' ');
  }
  /* Serienøkkel: merket pluss første ord etter merket i navnet. «SAISEI IRO Sakura» og «SAISEI IRO Skog» blir samme serie. */
  function serie(navn, merke) {
    var n = (navn || '').trim(), m = (merke || '').trim();
    var rest = (m && n.toLowerCase().indexOf(m.toLowerCase()) === 0) ? n.slice(m.length).trim() : n;
    var ord = rest.split(/\s+/);
    return (m + ' ' + (ord[0] || '')).toLowerCase().trim();
  }
  /* Antall kniver i et prisbånd som passer jobben og stellet. Vises under prisbåndene (t3). */
  function antall(alle, s, b) {
    var typer = [].concat.apply([], TYPER[s.bruk] || TYPER.alt);
    return alle.filter(function (k) { return k.tilgjengelig !== false && typer.indexOf(k.type) !== -1 && stellOk(k, s.stell) && baand(k.pris) === b; }).length;
  }
  return { velg: velg, grunn: grunn, steg: steg, baand: baand, oppsett: oppsett, serie: serie, antall: antall, T: T, fyll: fyll };
})();
if (typeof module !== 'undefined' && module.exports) module.exports = TsKgMotor;
/* MOTOR SLUTT */

(function () {
  if (typeof document === 'undefined') return;
  var T = TsKgMotor.T, fyll = TsKgMotor.fyll;
  var NAVN = { jobb: 'bruk', stell: 'stell', skaft: 'skaft', pris: 'pris' };

  function start(rot) {
    if (!rot || rot.getAttribute('data-ts-kg-klar')) return;
    rot.setAttribute('data-ts-kg-klar', '1');
    var $ = function (s) { return rot.querySelector(s); };
    var skjema = $('[data-ts-kg-skjema]');
    var prog = $('[data-ts-kg-prog]');
    var stegtekst = $('[data-ts-kg-stegtekst]');
    var strek = $('[data-ts-kg-strek]');
    var tilbake = $('[data-ts-kg-tilbake]');
    var svarBoks = $('[data-ts-kg-svar]');
    var rtittel = $('[data-ts-kg-rtittel]');
    var toydLinje = $('[data-ts-kg-toyd]');
    var skaftLinje = $('[data-ts-kg-skaft]');
    var vinnerBoks = $('[data-ts-kg-vinner]');
    var ingen = $('[data-ts-kg-ingen]');
    var hjelp = $('[data-ts-kg-hjelp]');
    var andreBoks = $('[data-ts-kg-andre]');
    var andreListe = $('[data-ts-kg-andre-liste]');
    var chips = $('[data-ts-kg-chips]');
    var endre = $('[data-ts-kg-endre]');
    var startKnapp = $('[data-ts-kg-start]');
    var pool = $('[data-ts-kg-pool]');
    if (!skjema || !pool) return;

    var grenser = (rot.getAttribute('data-grenser') || '').split(',').map(function (x) { return parseFloat(x); });
    var tekster = {};
    try { tekster = JSON.parse(rot.getAttribute('data-tekster') || '{}') || {}; } catch (e) { tekster = {}; }
    var oppsett = { grenser: grenser.every(function (x) { return isFinite(x); }) ? grenser : null, tekster: tekster };
    var tekst = function (k, std) { return (typeof tekster[k] === 'string' && tekster[k].trim()) ? tekster[k] : std; };
    var kort = Array.prototype.slice.call(pool.querySelectorAll('.ts-kg__produkt'));
    var data = kort.map(function (el, i) {
      var d = el.dataset;
      return {
        el: el,
        pris: parseFloat(d.pris) || 0,
        type: d.type,
        staal: d.staal,
        vedl: d.vedl || '',
        skaft: d.skaft || '',
        kledning: d.kledning || '',
        lengde: parseFloat(d.lengde) || 0,
        favoritt: d.favoritt === '1',
        passer: d.passer,
        merke: d.merke || '',
        serie: TsKgMotor.serie(d.navn, d.merke),
        tilgjengelig: true,
        rekke: i
      };
    });

    /* Skaftbildene: uten eget bilde i seksjonen lånes produktbildet til første kokkekniv med det skaftet. */
    ['wa', 'yo'].forEach(function (t) {
      var boks = rot.querySelector('[data-ts-kg-skaftbilde="' + t + '"]');
      if (!boks || boks.querySelector('img')) return;
      var med = data.filter(function (k) { return k.skaft === t && k.el.querySelector('img'); });
      var k = med.filter(function (x) { return x.type === 'gyuto'; })[0] || med[0];
      if (!k) { boks.hidden = true; return; }
      var img = k.el.querySelector('img').cloneNode(false);
      img.removeAttribute('loading');
      img.setAttribute('sizes', '(min-width: 650px) 460px, 100vw');
      img.alt = '';
      boks.appendChild(img);
    });

    var naa = null;
    var rettTilSvar = false;
    var dybde = -1;
    var logg = [];
    var timer = null;

    function fieldset(id) { return skjema.querySelector('[data-steg="' + id + '"]'); }
    function svar() {
      var s = {};
      Object.keys(NAVN).forEach(function (id) {
        var v = skjema.querySelector('input[name="' + NAVN[id] + '"]:checked');
        s[NAVN[id]] = v ? v.value : null;
      });
      return s;
    }
    /* 1/11 2026 (f05): prisbåndene er i kroner. Handler kunden i en annen valuta, hoppes prisspørsmålet over og regnes som «vet ikke». */
    var utenPris = (rot.getAttribute('data-valuta') || 'NOK') !== 'NOK';
    function synlige() { return TsKgMotor.steg().filter(function (id) { return !(utenPris && id === 'pris'); }); }
    function besvart(id) { return !!skjema.querySelector('input[name="' + NAVN[id] + '"]:checked'); }
    function forsteUbesvart() {
      var l = synlige();
      for (var i = 0; i < l.length; i++) { if (!besvart(l[i])) return l[i]; }
      return null;
    }

    /* Hvert trinn i nettleserhistorikken, så «tilbake» i nettleseren går ett trinn tilbake. */
    function husk(id, erstatt) {
      var l = synlige();
      /* 1/11 2026 (f16): svarene lagres også, så «tilbake» fra en produktside (uten bfcache) åpner samme trinn med svarene på plass. */
      var st = { tsKg: id, steg: l.indexOf(id) + 1, n: erstatt ? dybde : dybde + 1, svar: svar() };
      if (!erstatt) dybde++;
      logg.length = dybde + 1;
      logg[dybde] = id;
      try { history[erstatt ? 'replaceState' : 'pushState'](st, ''); } catch (e) {}
    }
    function gaaTil(id, erstatt) { husk(id, erstatt); vis(id, true); }

    function vis(id, fokus) {
      window.clearTimeout(timer);
      if (id === 'resultat') { if (forsteUbesvart()) id = forsteUbesvart(); else return visResultat(fokus); }
      naa = id;
      rot.classList.remove('er-intro', 'er-ferdig');
      svarBoks.hidden = true;
      var l = synlige();
      var pos = l.indexOf(id);
      if (pos === -1) { id = l[0]; pos = 0; naa = id; }
      Array.prototype.forEach.call(skjema.querySelectorAll('[data-steg]'), function (f) {
        f.classList.toggle('er-aktiv', f.getAttribute('data-steg') === id);
      });
      /* 27/10 2026 (f7): «Spørsmål 2 av 4» foran etiketten, og streken som fremdriftsmåler for skjermleser. */
      var stegAv = (stegtekst.getAttribute('data-steg-av') || 'Spørsmål [n] av [m]').replace('[n]', pos + 1).replace('[m]', l.length);
      stegtekst.textContent = stegAv + ' · ' + fieldset(id).getAttribute('data-etikett');
      strek.style.width = ((pos + 1) / l.length * 100) + '%';
      var strekBoks = strek.parentNode;
      if (strekBoks) { strekBoks.setAttribute('role', 'progressbar'); strekBoks.setAttribute('aria-valuemin', '0'); strekBoks.setAttribute('aria-valuemax', String(l.length)); strekBoks.setAttribute('aria-valuenow', String(pos + 1)); strekBoks.setAttribute('aria-label', stegAv); strekBoks.removeAttribute('aria-hidden'); }
      tilbake.hidden = pos === 0;
      prog.hidden = false;
      if (id === 'pris') visAntall();
      if (fokus) {
        var q = fieldset(id).querySelector('.ts-kg__q');
        if (q) q.focus({ preventScroll: true });
        skjema.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    var antallTekst = rot.getAttribute('data-antall-tekst') || '';
    function visAntall() {
      if (!antallTekst) return;
      var s = svar();
      TsKgMotor.oppsett(oppsett);
      Array.prototype.forEach.call(skjema.querySelectorAll('[data-ts-kg-antall]'), function (el) {
        var n = TsKgMotor.antall(data, s, el.getAttribute('data-ts-kg-antall'));
        el.textContent = n ? antallTekst.replace('[n]', n) : '';
      });
    }

    function visIntro() {
      naa = null;
      rot.classList.add('er-intro');
      rot.classList.remove('er-ferdig');
      prog.hidden = true;
      svarBoks.hidden = true;
      Array.prototype.forEach.call(skjema.querySelectorAll('[data-steg]'), function (f) { f.classList.remove('er-aktiv'); });
    }

    function tilbakeTilLager() { kort.forEach(function (k) { pool.appendChild(k); }); }

    function lagTittel(k) {
      var typenavn = k.el.dataset.typenavn;
      rtittel.textContent = typenavn ? (k.lengde ? fyll(T.tittel_lengde, { type: typenavn, lengde: k.lengde }) : typenavn) : tekst('tittel', T.resultat_tittel);
    }

    function lagMerker() {
      chips.innerHTML = '';
      synlige().forEach(function (id) {
        var inp = skjema.querySelector('input[name="' + NAVN[id] + '"]:checked');
        if (!inp) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ts-kg__merke';
        b.textContent = inp.dataset.merke;
        b.setAttribute('aria-label', fyll(T.endre, { merke: inp.dataset.merke }));
        b.addEventListener('click', function () { rettTilSvar = true; gaaTil(id); });
        chips.appendChild(b);
      });
    }

    function visResultat(fokus) {
      var s = svar();
      TsKgMotor.oppsett(oppsett);
      var r = TsKgMotor.velg(data, s);
      naa = 'resultat';
      tilbakeTilLager();
      Array.prototype.forEach.call(skjema.querySelectorAll('[data-steg]'), function (f) { f.classList.remove('er-aktiv'); });
      prog.hidden = true;
      rot.classList.remove('er-intro');
      rot.classList.add('er-ferdig');

      if (r.vinner) {
        lagTittel(r.vinner);
        rtittel.hidden = false;
        r.vinner.el.querySelector('[data-ts-kg-grunn]').textContent = TsKgMotor.grunn(r.vinner, s);
        vinnerBoks.appendChild(r.vinner.el);
        toydLinje.textContent = r.toyd === 'over' ? tekst('toyd_over', T.toyd_over) : (r.toyd === 'under' ? tekst('toyd_under', T.toyd_under) : '');
        toydLinje.hidden = !r.toyd;
        skaftLinje.hidden = !r.skaftMangler;
        r.andre.forEach(function (k) { andreListe.appendChild(k.el); });
        andreBoks.hidden = !r.andre.length;
        ingen.hidden = true;
        hjelp.hidden = false;
      } else {
        rtittel.hidden = true;
        toydLinje.hidden = true;
        skaftLinje.hidden = true;
        andreBoks.hidden = true;
        hjelp.hidden = true;
        ingen.hidden = false;
      }
      lagMerker();
      svarBoks.hidden = false;
      if (fokus) {
        var mal = r.vinner ? rtittel : ingen;
        if (!r.vinner) ingen.setAttribute('tabindex', '-1');
        mal.focus({ preventScroll: true });
        svarBoks.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* Etter et svar: neste trinn, eller resultatet. Kom du fra en merkelapp, går vi rett til resultatet når alt er besvart. */
    function videre(id) {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (rettTilSvar) {
          var mangler = forsteUbesvart();
          if (!mangler) rettTilSvar = false;
          gaaTil(mangler || 'resultat');
          return;
        }
        var l = synlige();
        var neste = l[l.indexOf(id) + 1];
        if (neste) gaaTil(neste);
        else gaaTil(forsteUbesvart() || 'resultat');
      }, 220);
    }

    /* Tastatur: piltaster flytter bare fokus og valg. Enter og mellomrom går videre. Klikk og touch går videre. */
    var peker = false;
    skjema.addEventListener('pointerdown', function () { peker = true; });
    skjema.addEventListener('keydown', function (e) {
      peker = false;
      var inp = e.target;
      if (!inp || inp.type !== 'radio') return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        inp.checked = true;
        videre(inp.closest('[data-steg]').getAttribute('data-steg'));
      }
    });
    skjema.addEventListener('click', function (e) {
      var inp = e.target;
      if (!inp || inp.type !== 'radio' || !peker) return;
      peker = false;
      videre(inp.closest('[data-steg]').getAttribute('data-steg'));
    });
    skjema.addEventListener('submit', function (e) { e.preventDefault(); });

    tilbake.addEventListener('click', function () {
      rettTilSvar = false;
      var l = synlige();
      var forrige = l[l.indexOf(naa) - 1];
      if (!forrige) return;
      if (dybde > 0 && logg[dybde - 1] === forrige) history.back();
      else gaaTil(forrige, true);
    });

    endre.addEventListener('click', function () {
      Array.prototype.forEach.call(skjema.querySelectorAll('input:checked'), function (inp) { inp.checked = false; });
      rettTilSvar = false;
      tilbakeTilLager();
      gaaTil('jobb');
    });

    if (startKnapp) startKnapp.addEventListener('click', function () { rettTilSvar = false; gaaTil('jobb'); });

    window.addEventListener('popstate', function (e) {
      if (!document.body.contains(rot)) return;
      var st = e.state;
      if (!st || !st.tsKg) { dybde = -1; logg.length = 0; tilbakeTilLager(); visIntro(); return; }
      dybde = typeof st.n === 'number' ? st.n : dybde;
      logg[dybde] = st.tsKg;
      vis(st.tsKg, true);
    });

    /* Nettleserens egen skjemagjenoppretting ryddes bort; svarene kommer fra historikken (f16) eller starter tomme. */
    Array.prototype.forEach.call(skjema.querySelectorAll('input:checked'), function (inp) { inp.checked = false; });
    rot.classList.add('er-js', 'er-intro');
    var lagret = history.state;
    if (lagret && lagret.tsKg && lagret.svar) {
      Object.keys(lagret.svar).forEach(function (navn) {
        var v = lagret.svar[navn];
        if (v == null) return;
        Array.prototype.forEach.call(skjema.querySelectorAll('input[name="' + navn + '"]'), function (inp) { if (inp.value === v) inp.checked = true; });
      });
      dybde = typeof lagret.n === 'number' ? lagret.n : 0; logg.length = 0; logg[dybde] = lagret.tsKg;
      vis(lagret.tsKg, false);
    } else {
      dybde = 0; logg.length = 0; logg[0] = 'jobb';
      try { history.replaceState({ tsKg: 'jobb', steg: 1, n: 0 }, ''); } catch (e) {}
      vis('jobb', false);
    }
  }

  function startAlle(innenfor) {
    Array.prototype.forEach.call((innenfor || document).querySelectorAll('.ts-kg'), start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { startAlle(); });
  else startAlle();
  /* Temaeditoren: seksjonen lastes på nytt uten at siden gjør det. */
  document.addEventListener('shopify:section:load', function (e) { startAlle(e.target); });
})();
